import BigNumber from 'bignumber.js';

import { CREDITS_TO_USD_RATE } from '../constants';

export const convertCreditsToUSD = (
  credits: number,
  decimalPlaces = 0,
  promoExtraRate = 1, // promoExtraRate for Deal and Ankr payments is 1.2 (DEAL_PROMO_EXTRA_REQUESTS_RATE)
) =>
  new BigNumber(credits)
    .dividedBy(CREDITS_TO_USD_RATE)
    .dividedBy(promoExtraRate)
    .decimalPlaces(decimalPlaces);
